import { Renderer_Order } from './Renderer_Order.js';
import { asArray, MUSTNeverHappenException } from '@nu-art/ts-common';
import { ModuleFE_Advisor_Resource, ModuleFE_AdvisorSession } from '@app/advisor-frontend';
import { ModuleFE_Advisor_Action } from '@app/advisor-frontend';
import { ICONS } from '@app/styles';
import { stopPropagation } from '@nu-art/thunderstorm-frontend/index';
import { ModuleFE_RuntimeOrder } from '@app/advisor-frontend';
import { ModuleFE_AdvisorAnalytics } from '../../../../_analytics/consts.js';
import { OrderPlacedSource } from '../../../../_analytics/types.js';
import { ResourceType_Consultations, ResourceType_EKG, ResourceType_Imaging } from '@app/hcs-shared';
import { RuntimeOrderStatus_Enum } from '@app/advisor-shared';
import { ModuleFE_EMInterface } from '@app/advisor-frontend';
export class Renderer_Order_General extends Renderer_Order {
    __onReadOnlyChanged() {
        if (!ModuleFE_EMInterface.isReadonly())
            this.reDeriveState({ disabled: false });
    }
    __onRuntimeOrdersUpdated = (...params) => {
        const rtOrderIds = asArray(params[1]).map(rtOrder => rtOrder._id);
        if (rtOrderIds.includes(this.props.rtOrder._id))
            this.reDeriveState();
    };
    deriveStateFromProps(nextProps, state) {
        state.order ??= ModuleFE_Advisor_Action.cache.unique(nextProps.rtOrder.orderId);
        //Determine resource type
        if (!state.resourceType) {
            if (!ModuleFE_Advisor_Action.is.order(state.order)) {
                state.resourceType = 'general';
            }
            else {
                if (state.order.subType === 'treatment')
                    state.resourceType = 'treatment';
                else {
                    const resource = ModuleFE_Advisor_Resource.cache.unique(state.order.resourceId);
                    if (state.order.resourceId && !resource)
                        throw new MUSTNeverHappenException(`Could not get resource for id ${state.order.resourceId}`);
                    // handle ekg edge case
                    if (resource?.label === ResourceType_EKG)
                        state.resourceType = 'ekg';
                    else
                        switch (resource?.type) {
                            case ResourceType_Imaging:
                                state.resourceType = 'imaging';
                                break;
                            case ResourceType_Consultations:
                                state.resourceType = 'consult';
                                break;
                            default:
                                state.resourceType = 'general';
                                break;
                        }
                }
            }
        }
        //Determine if order is available
        if (!state.order.variableId || !state.order.resourceId || ModuleFE_EMInterface.isReadonly())
            state.disabled = true;
        //Determine order status
        state.orderStatus = nextProps.rtOrder?.orderStatus !== RuntimeOrderStatus_Enum.RECOMMENDED ? 'Ordered' : undefined;
        return state;
    }
    onOrderClick = async (e) => {
        stopPropagation(e);
        try {
            await ModuleFE_RuntimeOrder.acceptOrders([this.props.rtOrder._id]);
            ModuleFE_AdvisorAnalytics.trigger.orders.order_placed({
                orderId: this.state.order._id,
                orderLabel: this.state.order.label ?? this.state.order.name,
                source: OrderPlacedSource.suggestedWorkup,
            });
            this.props.onOrderComplete?.();
            // if enable AGL is disabled, exit
            if (!ModuleFE_AdvisorSession.getEnableAgl())
                return;
            // post order to epic
            ModuleFE_RuntimeOrder.postEpicOrder(this.state.order._id);
        }
        catch (err) {
            this.logError(`Failed to send order ${this.state.order.name}`);
        }
    };
    getDisabled = () => {
        return this.state.disabled || this.state.orderStatus === 'Ordered';
    };
    getOrderIcon = () => {
        switch (this.state.resourceType) {
            case 'consult':
                return ICONS.advisor_avn_consultation;
            case 'ekg':
                return ICONS.advisor_avn_ekg;
            case 'imaging':
                return ICONS.advisor_avn_imaging;
            case 'treatment':
                return ICONS.advisor_avn_medication;
            default:
                return ICONS.advisor_avn_labs;
        }
    };
    getOrderLabel = () => {
        return this.state.order.name;
    };
    getVariant = () => {
        //Variant of an order waiting for results
        if (this.state.orderStatus === 'Ordered')
            return 'order-ordered';
        switch (this.state.resourceType) {
            case 'treatment':
            case 'consult':
                return 'order-secondary';
            default:
                return 'order-primary';
        }
    };
}
//# sourceMappingURL=Renderer_Order_General.js.map